module.exports = __webpack_public_path__ + "media/images/back_yellow-a3318774dbd3649e44ca6feea6849056.gif";